/** Design tokens for marketing email UI — light & dark mode. */

export const mePageWrapClass = '-mx-2 -my-2 sm:-mx-4 sm:-my-4 md:-mx-6 md:-my-6';

export const meShellClass =
  'flex h-[calc(100vh-7.5rem)] min-h-[32rem] overflow-hidden rounded-2xl border border-gray-200/80 bg-gray-50 shadow-sm dark:border-gray-700/80 dark:bg-gray-950';

export const meSidebarClass =
  'flex w-[13.5rem] shrink-0 flex-col border-r border-gray-200/80 bg-white dark:border-gray-800 dark:bg-gray-900';

export const meComposeBtnClass =
  'mx-3 mt-4 flex items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-primary-600 active:scale-[0.98]';

export const meNavItemClass = (active: boolean) =>
  [
    'mx-2 flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition',
    active
      ? 'bg-primary/10 font-medium text-primary dark:bg-primary/20 dark:text-primary-300'
      : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800',
  ].join(' ');

export const meListPanelClass =
  'flex w-[17rem] shrink-0 flex-col border-r border-gray-200/80 bg-white dark:border-gray-800 dark:bg-gray-900 xl:w-80';

export const meMainPanelClass =
  'flex min-w-0 flex-1 flex-col bg-white dark:bg-gray-900';

export const mePanelHeaderClass =
  'flex shrink-0 items-center justify-between border-b border-gray-200/80 px-5 py-3 dark:border-gray-800';

export const mePanelTitleClass = 'text-sm font-semibold text-gray-900 dark:text-gray-100';

export const meCardClass =
  'rounded-xl border border-gray-200/80 bg-gray-50/50 dark:border-gray-800 dark:bg-gray-950/50';

export const meInputClass =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-primary focus:ring-2 focus:ring-primary/20 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-500 dark:focus:border-primary-400';

export const meSelectClass = meInputClass;

export const meTextareaClass =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-primary focus:ring-2 focus:ring-primary/20 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-500';

export const meLabelClass = 'mb-1.5 block text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400';

export const mePrimaryBtnClass =
  'inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-50';

export const meSecondaryBtnClass =
  'inline-flex items-center justify-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800';

export const meGhostBtnClass =
  'inline-flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800';

export const meIconBtnClass =
  'rounded-lg p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200';

export const meTabClass = (active: boolean) =>
  [
    'rounded-lg px-3 py-1.5 text-sm font-medium transition',
    active
      ? 'bg-white text-primary shadow-sm dark:bg-gray-800 dark:text-primary-300'
      : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200',
  ].join(' ');

export const meTabBarClass =
  'inline-flex gap-1 rounded-xl bg-gray-100 p-1 dark:bg-gray-800';

export const meBadgeClass = (variant: 'draft' | 'scheduled' | 'sent' | 'sending' | 'failed') => {
  const map = {
    draft: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
    scheduled: 'bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300',
    sent: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300',
    sending: 'bg-blue-50 text-blue-700 dark:bg-blue-950/50 dark:text-blue-300',
    failed: 'bg-red-50 text-red-700 dark:bg-red-950/50 dark:text-red-300',
  };
  return `rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${map[variant]}`;
};

export const meEmptyStateClass =
  'flex flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center';

export const meModalOverlayClass = 'fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm';

export const meModalPanelClass =
  'flex max-h-[90vh] w-full flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900';
